import { decode } from './decode';

import type { PoiInfo } from '../interfaces';

export const ActivityPopup = ({ name, typeName, address, place, postCode, iconUrl }: PoiInfo) => (
    <div className="poiPopupContent">
        <ul className="poi_popuplist">
            <li id="poi_1_600">
                <img src={iconUrl} alt={decode(typeName)} />
                <span>{decode(typeName)}</span>
                <ul id="poi_2_600">
                    <li>
                        <div>
                            <ul>
                                <li className="pb_name">{decode(name)}</li>
                                {address && <li className="pb_address">{decode(address)}</li>}
                                {address && (
                                    <li className="pb_place">
                                        {postCode} {decode(place)}
                                    </li>
                                )}
                            </ul>
                        </div>
                    </li>
                </ul>
            </li>
        </ul>
    </div>
);
